import Collection from '../../ModelBinding/Collection';
import MissionMedia from './MissionMedia';
import Reason from '../Reason/Reason';
import ReasonCollection from '../Reason/ReasonCollection';
import _ from 'lodash';

export default class MissionMediaCollection extends Collection<MissionMedia> {
  static getModel() {
    return MissionMedia;
  }
  
  canBeSetAside():Boolean {
    return !!(this.length > 0 && this.every(media => media.canBeSetAside()));
  }

  canBeRejected():Boolean {
    return !!(this.length > 0 && this.every(media => media.canBeRejected()));
  }
  
  canBePostQC():Boolean {
    return !!(this.length > 0 && this.every(media => media.canBePostQC()));
  }

  canBeWaitingEdition():Boolean {
    return !!(this.length > 0 && this.every(media => media.canBeWaitingEdition()));
  }

  canBePreQC():Boolean {
    return !!(this.length > 0 && this.every(media => media.canBePreQC()));
  }

  canBeUnsetAside():Boolean {
    return !!(this.length > 0 && this.every(media => media.canBeUnsetAside()));
  }

  canHaveFeedback():Boolean {
    // TO DO REFACTO with feedback reasons
    return !!(this.length > 0 && this.every(media => media.canHaveFeedback()));
    /* return this.getCommonReasons().some(
      (reason: Reason) => reason.code && reason.code.match(/^(?!DIS|REF)\w+\d+$/),
    ); */
  }
}
